import { PhoneNumberHelper, UrlHelper } from '..'

class LoginHelper {
  getAuthUrlDetails(search: string) {
    return {
      id: UrlHelper.getQueryParam(search, 'id'),
      type: UrlHelper.getQueryParam(search, 'type'),
      phoneNumber: UrlHelper.getQueryParam(search, 'phoneNumber')
        ? PhoneNumberHelper.parsePhoneNumber(UrlHelper.getQueryParam(search, 'phoneNumber') as string)
        : null,
      tripLegId: UrlHelper.getQueryParam(search, 'tripLegId'),
      email: UrlHelper.getQueryParam(search, 'email'),
      country: UrlHelper.getQueryParam(search, 'country'),
      source: UrlHelper.getQueryParam(search, 'source'),
    }
  }

  getTripLegUrlDetails(path: string, search: string) {
    return {
      phoneNumber: UrlHelper.getQueryParam(search, 'phoneNumber'),
      tripLegId: UrlHelper.getLastPathItem(path),
    }
  }
}

export default new LoginHelper()
